import styled, { keyframes } from "styled-components";

const slideLeft = keyframes`
  from{
    transform:translateX(500px)
  }
  to{
    transform:translateX(0px)
  }
`;

export const Container = styled.div`
  width: ${({ theme }) => theme.searchBar.width};
  height: fit-content;
  position: relative;
  z-index: ${({ theme }) => theme.zIndex.dropdown};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
    position: inherit;
  }
`;

export const AutocompleteContainer = styled.div`
  position: absolute;
  width: calc(100%);
  top: 100%;
  margin-top: ${({ theme }) => theme.autocomplete.gap};
  z-index: ${({ theme }) => theme.zIndex.dropdown};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    left: 0;
    top: 50px;
    margin-top: 8px;
    height: auto;
    max-height: 50vh;
    overflow-y: auto;
    animation: ${slideLeft} 0.2s ease-in-out;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const PlaceholderOverlay = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  user-select: none;
  color: ${({ theme }) => theme.grey3};
  font-family: ${({ theme }) => theme.p1m.ff};
  font-size: 14px;
  letter-spacing: 0.2px;
  transition: color 0.18s ease;
`;

export const StyledSearch = styled.div`
  position: relative;
  width: ${({ theme }) => theme.searchBar.width};
  height: ${({ theme }) => theme.searchBar.height};
  background-color: ${({ theme, $isFocused }) =>
    $isFocused ? theme.backgroundLighter : theme.backgroundLight};
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: ${({ theme }) => theme.spacing[2]};
  border-radius: ${({ theme }) => theme.br.pill};
  transition: background-color 0.18s ease, opacity 0.18s ease;

  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};

  &:hover,
  &:focus-within {
    background-color: ${({ theme, $disabled }) =>
      $disabled ? theme.backgroundLight : theme.backgroundLighter};
  }

  .input {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: transparent;
    color: ${({ theme }) => theme.textLight};
    font-family: ${({ theme }) => theme.p1m.ff};
    font-size: 14px;
    letter-spacing: 0.2px;
    border: none;
    outline: none;
    margin-left: 8px;
    border-radius: 20px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
  }
`;

export const Results = styled.div`
  background: ${({ theme }) => theme.backgroundLight};
  border-radius: ${({ theme }) => theme.autocomplete.borderRadius};
  box-shadow: ${({ theme }) => theme.dropdownMenu.boxShadow};
  max-height: 450px;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    width: 8px;
    opacity: 0;
    border-radius: 12px;
  }

  ::-webkit-scrollbar-track {
    opacity: 0;
    width: 15px;
    background-color: ${({ theme }) => theme.backgroundDark};
    border-radius: 12px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.06);
    opacity: 0.6;
    border-radius: 12px;
  }

  .focused-result {
    background: ${({ theme }) => theme.backgroundLighter};
  }

  .result {
    display: flex;
    align-items: center;
    height: ${({ theme }) => theme.autocomplete.rowHeight};
    padding-left: ${({ theme }) => theme.autocomplete.iconPadding};
    padding-right: ${({ theme }) => theme.autocomplete.iconPadding};
    cursor: pointer;

    &:hover {
      background: ${({ theme }) => theme.backgroundLighter};
    }

    .result-icon {
      flex-shrink: 0;
    }

    .name {
      flex: 1;
      margin-left: ${({ theme }) => theme.autocomplete.iconPadding};
      font-family: ${({ theme }) => theme.p3b.ff};
      font-size: ${({ theme }) => theme.p3b.fs};
      color: ${({ theme }) => theme.textLight};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .type {
      flex-shrink: 0;
      font-family: ${({ theme }) => theme.p3m.ff};
      font-size: ${({ theme }) => theme.p3m.fs};
      color: ${({ theme }) => theme.textMedium};
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100vw;
    border-radius: 0px;
    padding-top: 20px;
    padding-left: 4px;
    z-index: 200;
    background: ${({ theme }) => theme.backgroundDark};
    max-height: none;
    overflow-y: hidden;

    .type {
      padding-right: 6vw;
      text-align: left;
    }

    .result {
      padding: 12px;
      border-bottom: 0.1px solid #252525;
    }
  }
`;

export const MobileSearchInput = styled.div`
  display: flex;
  align-items: center;
  & .ant-input {
    flex: 1;
    margin-left: 3vw;
    /* height: 72px; */
    width: 100%;
    background: ${props => props.theme.backgroundDark};
    border: none;
    color: ${props => props.theme.textLight};
    font-size: ${props => props.theme.h3.fs};
    padding-top: 12px;
  }

  & .ant-input::placeholder {
    margin-top: 16px;
    color: ${props => props.theme.textDark};
    font-size: ${props => props.theme.h3.fs};
  }

  & .ant-input:focus {
    border-width: 0px;
    box-shadow: none;
  }

  .close-icon {
    margin-top: 6px;
    margin-right: 12px;
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
`;
